/** Read a cookie value (for CSRF, etc.) */
/**
 *
 * @param {string} name cookie name (e.g. csrf_token)
 * @returns {string} cookie value
 */
// export function getCookie(name) {
//   const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
//   return m ? decodeURIComponent(m[1]) : null;
// }

export function getCookie(name) {
  const nameEQ = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null; // Return null if the cookie is not found
}
